import {Card} from '@atoms';
import {IconButton} from '@molecules';
import {H3} from '@quarks';
import {useTranslation} from 'react-i18next';
import {DayItem} from './DayItem';
import {ScheduleItem} from './ScheduleItem';
import {cn} from '@utils';
import {useConnections} from 'src/components/pages/Connections/ConnectionsContext';
import {useParams} from 'react-router-dom';
import {getAcceptedGroupMembersWithWorkdays, useAppSelector} from '@lib/store';

type Props = {};

export const Schedule = (props: Props) => {
  const {t} = useTranslation();

  const {
    weekLabel,
    showWeekends,
    moveToNextWeek,
    moveToPreviousWeek,
    canMoveToNextWeek,
    canMoveToPreviousWeek,
    daysForSelectedWeek,
    compactView,
  } = useConnections();
  const {groupId} = useParams();
  const groupMembersWithWorkdays = useAppSelector((state) => getAcceptedGroupMembersWithWorkdays(state, groupId || ''));

  return (
    <Card
      className={cn(
        'grid grid-cols-[repeat(5,min-content)] rounded-none sm:rounded-lg+ justify-between gap-x-2 md:gap-x-4 px-4 md:px-8 [&>hr:last-of-type]:hidden overflow-clip',
        {
          'grid-cols-[repeat(7,min-content)]': showWeekends,
        },
        ['md:grid-cols-[minmax(0,240px)_repeat(5,1fr)] md:rounded-lg+'],
        [
          'md:grid-cols-[minmax(0,240px)_repeat(5,1fr)]',
          {'md:grid-cols-[minmax(0,240px)_repeat(7,1fr)]': showWeekends},
        ],
      )}>
      <div className="grid col-span-full md:col-span-1 grid-cols-[auto_1fr_auto] gap-8 md:gap-2 items-center pt-4 md:py-8 md:justify-between">
        <IconButton
          onClick={moveToPreviousWeek}
          className="order-1 md:ml-auto md:order-2"
          size="small"
          iconButton={'tertiary'}
          icon={'caretLeft'}
          disabled={!canMoveToPreviousWeek}
        />
        <H3 className="text-nowrap p-0 text-center md:text-left order-2 md:order-1">{weekLabel}</H3>
        <IconButton
          className="order-3"
          onClick={moveToNextWeek}
          size="small"
          iconButton={'tertiary'}
          icon={'caretRight'}
          disabled={!canMoveToNextWeek}
        />
      </div>

      {!compactView && <hr className="col-span-full -mx-4 md:-mx-8 row-start-2" />}

      <div className="grid grid-cols-subgrid col-span-full items-center row-start-2 py-4 md:py-8 justify-between">
        <span className="hidden md:inline-block" />
        {daysForSelectedWeek.map((day, index) => (
          <DayItem
            key={index}
            dayKey={day}
          />
        ))}
      </div>

      <hr className="col-span-full -mx-4 md:-mx-8" />

      {groupMembersWithWorkdays.map((groupMemberWithWorkdays, index) => (
        <ScheduleItem
          key={index}
          groupMemberWithWorkdays={groupMemberWithWorkdays}
        />
      ))}
    </Card>
  );
};
